export default __webpack_public_path__ + "static/media/closeWhite.859b115b.svg";